module.exports = __webpack_public_path__ + "static/media/sword-rare.7be81804.png";